"use client";

import { c as _c } from "react/compiler-runtime";
import { IconBoltOutline18, IconChartActivityOutline18 } from "nucleo-ui-outline-18";
import { NodeIconTile } from "@/components/ui/node-icon-tile";
import { formatNumber } from "@/lib/utils/formatNumber";
import Link from "next/link";
export interface IntegrationCardProps {
  integration: {
    type: string;
    name: string;
    description: string;
    platform?: string;
    logoUrl?: string;
    tags?: string[];
    integrationType: "trigger" | "action";
    payloadSchema?: {
      required?: string[];
      properties?: Record<string, unknown>;
    };
    connector?: {
      type: string;
    };
  };
  statistics?: {
    workflowsCount?: number;
    totalExecutions?: number;
    successRate?: number | null;
  };
  statsLoading?: boolean;
  highlightedTag?: string;
  showMetadata?: boolean;
  onTagClick?: (tag: string) => void;
  connectorLogoUrl?: string;
}
export function IntegrationCard(t0) {
  const $ = _c(52);
  const {
    integration,
    statistics,
    statsLoading: t1,
    highlightedTag,
    showMetadata: t2,
    onTagClick,
    connectorLogoUrl
  } = t0;
  const statsLoading = t1 === undefined ? false : t1;
  const showMetadata = t2 === undefined ? false : t2;
  const isTrigger = integration.integrationType === "trigger";
  const hasStats = !statsLoading && statistics;
  const detailUrl = `/integrations/${integration.integrationType}/${integration.type}`;
  let t3;
  if ($[0] !== integration.payloadSchema?.required) {
    t3 = integration.payloadSchema?.required || [];
    $[0] = integration.payloadSchema?.required;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const requiredFields = t3;
  let t4;
  if ($[2] !== integration.payloadSchema?.properties) {
    t4 = Object.keys(integration.payloadSchema?.properties || {});
    $[2] = integration.payloadSchema?.properties;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const allFields = t4;
  let t5;
  if ($[4] !== connectorLogoUrl || $[5] !== integration.connector) {
    t5 = integration.connector ? {
      type: integration.connector.type,
      logoUrl: connectorLogoUrl
    } : undefined;
    $[4] = connectorLogoUrl;
    $[5] = integration.connector;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const connectorProp = t5;
  const t6 = isTrigger ? "#2450FF" : "#22c55e";
  let t7;
  if ($[7] !== connectorProp || $[8] !== integration.description || $[9] !== integration.logoUrl || $[10] !== integration.name || $[11] !== integration.type || $[12] !== t6) {
    t7 = <NodeIconTile size="lg" id={integration.type} subject={integration.name} context={integration.description} logoUrl={integration.logoUrl} connector={connectorProp} alt={integration.name} color={t6} />;
    $[7] = connectorProp;
    $[8] = integration.description;
    $[9] = integration.logoUrl;
    $[10] = integration.name;
    $[11] = integration.type;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== detailUrl || $[15] !== t7) {
    t8 = <Link href={detailUrl} prefetch={false} className="p-1">{t7}</Link>;
    $[14] = detailUrl;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = `rounded-full px-2.5 py-1 text-xs font-medium ${isTrigger ? "bg-yellow-50 text-yellow-700 dark:bg-yellow-500/10 dark:text-yellow-400" : "bg-green-50 text-green-700 dark:bg-green-500/10 dark:text-green-400"}`;
  const t10 = isTrigger ? "Trigger" : "Action";
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <span className={t9}>{t10}</span>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8) {
    t12 = <div className="mb-4 flex w-full items-start justify-between">{t8}{t11}</div>;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== integration.name) {
    t13 = <h3 className="text-ds-text-primary mb-2 text-base font-semibold hover:text-blue-600 dark:hover:text-blue-400">{integration.name}</h3>;
    $[23] = integration.name;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== integration.description) {
    t14 = <p className="body-sm mb-4 line-clamp-2">{integration.description}</p>;
    $[25] = integration.description;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== detailUrl || $[28] !== t13 || $[29] !== t14) {
    t15 = <Link href={detailUrl} prefetch={false} className="block">{t13}{t14}</Link>;
    $[27] = detailUrl;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== hasStats || $[32] !== statistics) {
    t16 = hasStats && (statistics.workflowsCount > 0 || statistics.totalExecutions > 0) && <div className="flex flex-wrap gap-2">{statistics.workflowsCount > 0 && <div className="inline-flex items-center gap-1 rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 dark:bg-blue-500/10 dark:text-blue-400"><IconBoltOutline18 className="h-3 w-3" /><span>{formatNumber(statistics.workflowsCount)} workflow{statistics.workflowsCount !== 1 ? "s" : ""}</span></div>}{statistics.totalExecutions > 0 && <div className="inline-flex items-center gap-1 rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 dark:bg-purple-500/10 dark:text-purple-400"><IconChartActivityOutline18 className="h-3 w-3" /><span>{formatNumber(statistics.totalExecutions)} run{statistics.totalExecutions !== 1 ? "s" : ""}</span></div>}{statistics.successRate !== null && statistics.successRate !== undefined && <div className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium ${statistics.successRate >= 90 ? "bg-green-50 text-green-700 dark:bg-green-500/10 dark:text-green-400" : statistics.successRate >= 70 ? "bg-yellow-50 text-yellow-700 dark:bg-yellow-500/10 dark:text-yellow-400" : "bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-400"}`}><span>{Math.round(statistics.successRate)}% success</span></div>}</div>;
    $[31] = hasStats;
    $[32] = statistics;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== highlightedTag || $[35] !== integration.tags || $[36] !== onTagClick) {
    t17 = integration.tags && integration.tags.length > 0 && <div className="flex flex-wrap gap-1.5">{integration.tags.slice(0, 3).map(tag => {
        const isHighlighted = tag === highlightedTag;
        const colorClasses = isHighlighted ? "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400" : "bg-ds-neutral-100 text-ds-text-secondary dark:bg-ds-neutral-800";
        if (onTagClick) {
          return <button key={tag} onClick={e => {
            e.preventDefault();
            onTagClick(tag);
          }} className={`${"rounded-md px-2 py-0.5 text-xs font-medium transition-colors"} ${colorClasses} hover:bg-ds-neutral-200 dark:hover:bg-ds-neutral-700`}>{tag}</button>;
        }
        return <Link key={tag} href={`/integrations/tag/${tag}`} className={`${"rounded-md px-2 py-0.5 text-xs font-medium transition-colors"} ${colorClasses} hover:bg-ds-neutral-200 dark:hover:bg-ds-neutral-700`}>{tag}</Link>;
      })}{integration.tags.length > 3 && <span className="bg-ds-neutral-100 text-ds-text-muted dark:bg-ds-neutral-800 rounded-md px-2 py-0.5 text-xs font-medium">+{integration.tags.length - 3}</span>}</div>;
    $[34] = highlightedTag;
    $[35] = integration.tags;
    $[36] = onTagClick;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== allFields || $[39] !== integration.platform || $[40] !== integration.type || $[41] !== requiredFields || $[42] !== showMetadata) {
    t18 = showMetadata && <div className="border-ds-neutral-100 dark:border-ds-neutral-800 space-y-2 border-t pt-4"><div className="flex items-center justify-between text-xs"><span className="text-ds-text-subtle dark:text-ds-text-disabled">Type:</span><span className="text-ds-text-primary font-mono">{integration.type}</span></div>{integration.platform && <div className="flex items-center justify-between text-xs"><span className="text-ds-text-subtle dark:text-ds-text-disabled">Platform:</span><span className="text-ds-text-primary font-medium">{integration.platform.charAt(0).toUpperCase() + integration.platform.slice(1)}</span></div>}<div className="flex items-center justify-between text-xs"><span className="text-ds-text-subtle dark:text-ds-text-disabled">Fields:</span><span className="text-ds-text-primary">{allFields.length} ({requiredFields.length} required)</span></div></div>;
    $[38] = allFields;
    $[39] = integration.platform;
    $[40] = integration.type;
    $[41] = requiredFields;
    $[42] = showMetadata;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t16 || $[45] !== t17 || $[46] !== t18) {
    t19 = <div className="mt-auto space-y-4">{t16}{t17}{t18}</div>;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t12 || $[49] !== t15 || $[50] !== t19) {
    t20 = <div className="border-ds-border-default hover:border-ds-neutral-300 dark:hover:border-ds-neutral-700 bg-ds-surface-card group flex flex-col rounded-xl border p-5 transition-all hover:shadow-md">{t12}{t15}{t19}</div>;
    $[48] = t12;
    $[49] = t15;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  return t20;
}